import { ModelBase } from 'store/model-base';

export class Usage extends ModelBase {
    public static storeName: string = 'usage';

    // some parameters are available in summary only
    // while some in detail only
    public voiceCounts: number;
    public voiceCost: number;
    public textCounts: number;
    public textCost: number;
    public voiceLog: UsageLog[];
    public textLog: UsageLog[];
    public dataConsumed: number;
    public dataCost: number;
    public dataLog: UsageLog[];

    public static create<T extends ModelBase>(data: ApiResponse): T {
        data.voiceLog = data.voiceLog || [];
        data.textLog = data.textLog || [];
        data.dataLog = data.dataLog || [];

        return super.create<T>(data);
    }
}
